// Backend Lambdas throw Error(JSON.stringify({ code, message, httpCode })), and
// AppSync surfaces that whole JSON blob as the GraphQL error `message`. Parse it
// back out so the UI can key on `code` and show `message` — never raw JSON.
type BackendError = { code?: string; message?: string; httpCode?: number };

export const parseBackendError = (raw?: string): BackendError => {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw) as BackendError;
    return typeof parsed === "object" && parsed !== null ? parsed : { message: raw };
  } catch {
    return { message: raw };
  }
};

// Operator-facing copy for backend error codes. Add codes here as they get
// dedicated UI treatment; anything unlisted falls back to the backend message.
const FRIENDLY_MESSAGES: Record<string, string> = {
  DUPLICATE_ACCOUNT_CODE:
    "This Account Code is already in use by another account. Please enter a different code."
};

export const friendlyBackendMessage = (raw: string | undefined, fallback: string): string => {
  const { code, message } = parseBackendError(raw);
  if (code && FRIENDLY_MESSAGES[code]) return FRIENDLY_MESSAGES[code];
  return message || raw || fallback;
};
